import { Validators } from "@angular/forms";

export interface CashInField {
  name: string;            
  label: string;           
  validators: any[];       
}

export const CASHIN_COUNTRY_FIELDS: Record<string, CashInField[]> =
{
  CLP: [
    { name:'customerName',       label:'common.fullName',  validators:[Validators.required] },
    { name:'customerEmail',      label:'common.email', validators:[Validators.required, Validators.email] },
    { name:'documentNumber',     label:'common.documentNumber',validators:[Validators.required] },
    { name:'documentType',       label:'common.documentTypeCLP',  validators:[Validators.required] },
  ],
  COP: [
    { name:'step',           label:'common.step',       validators:[Validators.required] },
    { name:'customerName',   label:'common.fullName',validators:[Validators.required] },
    { name:'customerPhone',  label:'common.phone',validators:[Validators.required] },
    { name:'customerEmail',  label:'common.email',validators:[Validators.required, Validators.email] },
    { name:'documentNumber', label:'common.documentNumber',validators:[Validators.required] },
    { name:'documentType',   label:'common.documentTypeCOP',validators:[Validators.required] },
    { name:'bankCode',       label:'common.bankCodeEx',   validators:[Validators.required] },
    { name:'accountNo',      label:'common.accountNo',  validators:[Validators.required] },
  ],
  PEN: [
    { name:'customerName',   label:'common.fullName',validators:[Validators.required] },
    { name:'customerPhone',  label:'common.phone',validators:[Validators.required] },
    { name:'customerEmail',  label:'common.email',validators:[Validators.required, Validators.email] },
    { name:'documentNumber', label:'common.documentNumber',validators:[Validators.required] },
    { name:'documentType',   label:'common.documentTypePEN',validators:[Validators.required] },
  ]
};
